import { EXAM_ADMIN_PAGE_PATHS, EXAM_COMMON_PAGE_PATHS } from "@airange/shared/exam-routes";
import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export default [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./routed/Login",
  },
  {
    path: EXAM_COMMON_PAGE_PATHS.changePassword,
    layout: false,
    component: "./routed/ChangePassword",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./routed/OidcCallback",
  },
  {
    path: "/",
    redirect: EXAM_ADMIN_PAGE_PATHS.dashboard,
  },
  {
    path: EXAM_ADMIN_PAGE_PATHS.dashboard,
    name: "admin.shell.menu.dashboard",
    icon: "dashboard",
    access: "canViewDashboard",
    component: "./routed/Dashboard",
  },
  {
    path: "/questions",
    name: "admin.shell.menu.questions",
    access: "canManageQuestions",
    component: "./routed/Questions",
  },
  {
    path: "/questions/create-code",
    name: "admin.shell.routes.questionDetail",
    hideInMenu: true,
    access: "canManageQuestions",
    component: "./routed/QuestionTaskCreateCode",
  },
  {
    path: "/questions/create-practical",
    name: "admin.shell.routes.questionDetail",
    hideInMenu: true,
    access: "canManageQuestions",
    component: "./routed/QuestionTaskCreatePractical",
  },
  {
    path: "/questions/create-attack-defense",
    name: "admin.shell.routes.questionDetail",
    hideInMenu: true,
    access: "canManageQuestions",
    component: "./routed/QuestionTaskCreateAttackDefense",
  },
  {
    path: "/questions/:questionCode/edit",
    name: "admin.shell.routes.questionDetail",
    hideInMenu: true,
    access: "canManageQuestions",
    component: "./routed/QuestionTaskEdit",
  },
  {
    path: "/papers",
    name: "admin.shell.menu.papers",
    access: "canManagePapers",
    component: "./routed/Papers",
  },
  {
    path: EXAM_ADMIN_PAGE_PATHS.exams,
    name: "admin.shell.menu.exams",
    access: "canManageExams",
    component: "./routed/Exams",
  },
  {
    path: "/review",
    name: "admin.shell.menu.review",
    access: "canReview",
    component: "./routed/Review",
  },
  {
    path: "/users/candidates",
    name: "admin.shell.menu.candidateUsers",
    access: "canViewCandidateUsers",
    component: "./routed/CandidateUsers",
  },
  {
    path: "/users/staff",
    name: "admin.shell.menu.staffUsers",
    access: "canManageUsers",
    component: "./routed/StaffUsers",
  },
  {
    path: "/system/custom-fields",
    name: "admin.shell.menu.customFields",
    access: "canManageSystem",
    component: "./routed/CustomFields",
  },
  {
    path: "/system/assets",
    name: "admin.shell.menu.assetsCenter",
    access: "canManageAssets",
    component: "./routed/AssetsCenter",
  },
  {
    path: "/docker/images",
    name: "admin.shell.menu.dockerImages",
    access: "canViewDocker",
    component: "./routed/DockerImages",
  },
  {
    path: "/docker/instances",
    name: "admin.shell.menu.dockerInstances",
    access: "canViewDocker",
    component: "./routed/DockerInstances",
  },
  {
    path: "/system/settings",
    name: "admin.shell.menu.systemSettings",
    access: "canManageSystem",
    component: "./routed/SystemSettings",
  },
  {
    path: "/system/role-permissions",
    name: "admin.shell.menu.rolePermissions",
    access: "canManageSystem",
    component: "./routed/RolePermissions",
  },
  {
    path: "/audit-logs/login",
    name: "admin.shell.menu.auditLoginLogs",
    access: "canViewAuditLogs",
    component: "./routed/AuditLoginLogs",
  },
  {
    path: "/audit-logs/operations",
    name: "admin.shell.menu.auditOperationLogs",
    access: "canViewAuditLogs",
    component: "./routed/AuditOperationLogs",
  },
  {
    path: "/execution",
    name: "admin.shell.menu.execution",
    access: "canViewExecution",
    component: "./routed/Execution",
  },
  {
    path: "/submissions",
    name: "admin.shell.menu.submissions",
    access: "canViewExecution",
    component: "./routed/Submissions",
  },
  {
    path: "/questions/:questionCode",
    name: "admin.shell.routes.questionDetail",
    hideInMenu: true,
    hideInBreadcrumb: true,
    access: "canManageQuestions",
    component: "./routed/QuestionDetail",
  },
  {
    path: "/papers/create/:paperType",
    name: "admin.shell.routes.paperDetail",
    hideInMenu: true,
    access: "canManagePapers",
    component: "./routed/PaperCreate",
  },
  {
    path: "/papers/manual-picker",
    name: "admin.shell.routes.manualPaperPicker",
    hideInMenu: true,
    access: "canManagePapers",
    layout: false,
    component: "./routed/ManualPaperPicker",
  },
  {
    path: "/papers/:paperCode",
    name: "admin.shell.routes.paperDetail",
    hideInMenu: true,
    access: "canManagePapers",
    component: "./routed/PaperDetail",
  },
  {
    path: "/exams/:examRef",
    name: "admin.shell.routes.examDetail",
    hideInMenu: true,
    access: "canManageExams",
    component: "./routed/ExamDetail",
  },
  {
    path: "/attempts/:attemptNo",
    name: "admin.shell.routes.attemptDetail",
    hideInMenu: true,
    access: "canViewExecution",
    component: "./routed/AttemptDetail",
  },
  {
    path: "/docker/instances/:containerId",
    name: "admin.shell.routes.dockerInstanceDetail",
    hideInMenu: true,
    access: "canViewDocker",
    component: "./routed/DockerInstanceDetail",
  },
  {
    path: "*",
    layout: false,
    component: "./routed/NotFound",
  },
];
